import { FlexRow, MaterialIcon, useModal, VerticalDivider } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { SEND_COMMAND_ACTION } from '../../constants/app';
import { useCamera } from '../../hooks/useCamera';
import { useStyles } from '../../hooks/useStyles';
import { availableActionsState } from '../../storage/app';
import { Asset } from '../../types/asset';
import { SecondaryDeviceDetail } from '../../types/device';
import CommandModal from '../commands/modal/CommandModal';
import { StyledTooltip } from '../ui/StyledTooltip';

type Props = {
  device: SecondaryDeviceDetail;
  asset: Asset;
};

function MultipleDeviceCardFooter({ device, asset }: Props) {
  const { css, theme } = useStyles();
  const { zoomTo } = useCamera();
  const { openModal: openCommandModal, closeModal: closeCommandModal, showModal: showCommandModal } = useModal();
  const actions = useRecoilValue(availableActionsState);

  const lng = device.point.coordinates[0];
  const lat = device.point.coordinates[1];

  return (
    <FlexRow
      classNames={css({
        alignItems: 'center',
        justifyContent: 'space-evenly',
        padding: theme.sizing.scale200,
      })}
    >
      {actions.includes(SEND_COMMAND_ACTION) && (
        <>
          <StyledTooltip
            content="Enviar comando"
            showArrow={false}
            placement="bottom"
            ignoreBoundary
          >
            <Button
              shape="circle"
              kind="tertiary"
              size="compact"
              onClick={openCommandModal}
            >
              <MaterialIcon name="settings_remote" />
            </Button>
          </StyledTooltip>
          <VerticalDivider />
        </>
      )}
      <StyledTooltip
        content="Encontrar en el mapa"
        showArrow={false}
        placement="bottom"
        ignoreBoundary
      >
        <Button
          shape="circle"
          kind="tertiary"
          size="compact"
          onClick={() => zoomTo({ lat, lng })}
        >
          <MaterialIcon name="location_searching" />
        </Button>
      </StyledTooltip>
      <CommandModal
        onClose={closeCommandModal}
        isOpen={showCommandModal}
        asset={asset}
        deviceIdent={device.ident}
      />
    </FlexRow>
  );
}

export default memo(MultipleDeviceCardFooter);
